export const filterInvalidProps = (props, classMap) => {
  const classMapKey = Object.keys(classMap)

  return Object.keys(props)
    .filter(key => classMapKey.indexOf(key) === -1)
    .reduce((currentObject, nextKey) => {
      currentObject[nextKey] = props[nextKey]

      return currentObject
    }, {})
}

export const getClassNames = (props, classMap, extraClassName) => {
  const extraClasses = [...extraClassName]

  if (props.className) {
    extraClasses.push(props.className)
  }

  return Object.keys(props)
    .filter(key => classMap[key])
    .map(
      key =>
        typeof props[key] === 'boolean'
          ? classMap[key]
          : `${classMap[key]}-${props[key]}`
    )
    .concat(extraClasses)
    .join(' ')
    .trim()
}



// WEBPACK FOOTER //
// ./src/components/Grid/utils.js